import React from "react";
import { Check } from "lucide-react";

/**
 * Real checkbox (CSS-driven, see .checkbox in global.css) — same
 * hidden-native-input + styled-box pattern as Switch.jsx. Used for
 * bulk-select rows (ParticipantsTab, TeamPage) — didn't exist anywhere in
 * the codebase before; GalleryDetail.jsx's bulk-select uses a click-to-toggle
 * image overlay instead of a real checkbox.
 */
const Checkbox = ({ checked, onChange, disabled = false, "aria-label": ariaLabel }) => (
  <label className="checkbox" onClick={(e) => e.stopPropagation()}>
    <input type="checkbox" checked={checked} onChange={onChange} disabled={disabled} aria-label={ariaLabel} />
    <span className="box"><Check size={12} strokeWidth={3} color="#fff" /></span>
  </label>
);

export default Checkbox;
